<app-valider-piece-jointe [pjAValider]="bdc.pieces_jointes" (fichiersEvent)="majPiecesJointes($event)">
</app-valider-piece-jointe>

<div class="col-12">
  <button class="btn btn-primary ml-auto float-right" style="margin-bottom: 12px;" (click)="valider()">Valider</button>

</div>